/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChartArea = createReactComponent("chart-area", "IconChartArea", [
  ["path", { d: "M4 19l16 0", key: "svg-0" }],
  ["path", { d: "M4 15l4 -6l4 2l4 -5l4 4l0 5l-16 0", key: "svg-1" }]
]);

export { IconChartArea as default };
//# sourceMappingURL=IconChartArea.js.map
